import React from 'react'
import { Delete } from 'lucide-react'

import { cn } from '@/lib/utils'
import { useTranslation } from '@/features/locale/LocaleProvider'
import { isValidAmountInputRaw } from '../../../../utils/amountInputFormat'

const DEFAULT_MAX_INTEGER_DIGITS = 24

export type AmountKeypadOptions = {
  maxDecimals?: number
  maxIntegerDigits?: number
}

function isValidAmountString(value: string, options?: AmountKeypadOptions) {
  if (!isValidAmountInputRaw(value)) return false

  const [integerPart = '', fractionalPart = ''] = value.split('.')
  const maxIntegerDigits = options?.maxIntegerDigits ?? DEFAULT_MAX_INTEGER_DIGITS
  if (integerPart.length > maxIntegerDigits) return false
  if (options?.maxDecimals != null && fractionalPart.length > options.maxDecimals) return false

  return true
}

export function applyAmountKeypadKey(current: string, key: string, options?: AmountKeypadOptions): string {
  if (key === 'backspace') {
    return current.slice(0, -1)
  }

  const next = current + key
  return isValidAmountString(next, options) ? next : current
}

type KeypadKey = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '.' | '0' | 'backspace'

const KEYPAD_ROWS: KeypadKey[][] = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['.', '0', 'backspace'],
]

export function MobileAmountKeypad({
  onKeyPress,
  className,
}: {
  onKeyPress: (key: KeypadKey) => void
  className?: string
}) {
  const t = useTranslation()

  return (
    <div className={cn('nm-mobile-simple__keypad', className)} role="group" aria-label={t.common.numericKeypad}>
      {KEYPAD_ROWS.map((row) => (
        <div key={row.join('-')} className="nm-mobile-simple__keypad-row">
          {row.map((key) => (
            <button
              key={key}
              type="button"
              className={cn(
                'nm-mobile-simple__keypad-key',
                key === 'backspace' && 'nm-mobile-simple__keypad-key--utility',
              )}
              onClick={() => onKeyPress(key)}
              aria-label={key === 'backspace' ? 'Borrar' : key === '.' ? 'Punto decimal' : key}
            >
              {key === 'backspace' ? <Delete className="size-5" aria-hidden /> : key}
            </button>
          ))}
        </div>
      ))}
    </div>
  )
}
